/**
 *@description 为图表计算高度
 *@param container 父容器
 *@param charts echarts对象
 *@param offsetX 横轴偏移，可不填，默认50px
 *@param offsetY 纵轴偏移，可不填，默认70px
*/
export function chartssize (container, charts, offsetX = 50, offsetY = 70) {
  function getStyle (el) {
    if (window.getComputedStyle) {
      const doc = window.getComputedStyle(el)
      const height = parseInt(doc.height)
      const width = parseInt(doc.width)
      return {height, width}
    } else {
      return {height: container.clientHeight, width: container.clientWidth}
    }
  }
  const {height, width} = getStyle(container, null)
  charts.resize({width: parseInt(width - offsetX), height: parseInt(height - offsetY)})
}



// WEBPACK FOOTER //
// ./src/utils/resize.js